import routes from './_routes'
import { RouteHandler, ScrollToTop } from './components'
import { SnackbarProvider } from './contexts/SnackBarContext'
import QueryProvider from './providers/QueryProvider'
import AccountStore from './stores/Account'
import THEME from './theme'
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import CssBaseline from '@mui/material/CssBaseline'
import _ from 'lodash'
import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { LastLocationProvider } from 'react-router-last-location'

import { ThemeProvider } from '@mui/material/styles'

/* Extended Caltex palette for reference
{
  grey: {
    light: '#D0D0D0',
    medium: '#979A9C'
  },
  havoline: {
    black: '#211E16',
    darkRed: '#5B1400',
    gold: '#FDB515'
  },
  delo: {
    blue: '#2459A9',
    darkBlue: '#003764',
    lightBlue: '#62B3E4'
  }
}
*/

const gtmParams = { id: import.meta.env.REACT_APP_TAG_MANAGER_KEY }

const updateFavicon = (href: string) => {
  let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.getElementsByTagName('head')[0].appendChild(link)
  }
  link.href = href
}

const App = observer(() => {
  useEffect(() => {
    if (
      !_.includes(window.location.pathname, '/staff') &&
      !AccountStore.isWhitelabel &&
      !_.includes(window.location.pathname, '/logged-out') &&
      !_.includes(window.location.pathname, '/login-failed')
    ) {
      AccountStore.isSharedLogin = true
    }
    AccountStore.getProfile()

    // Whitelabel modifications
    if (AccountStore.isWhitelabel) {
      if (AccountStore.isLabCheck) {
        document.body.classList.add('castrol')
        document.title = 'Castrol Labcheck'
        updateFavicon('/labcheck_favicon.png')
      } else if (AccountStore.isLubeWatch) {
        document.body.classList.add('chevron')
        document.title = 'Caltex LubeWatch'
        updateFavicon('/lubewatch_favicon.png')
      }
    } else {
      document.title = 'CMS | myKomatsu'
      updateFavicon('/cms/favicon.png')
    }
  }, [])

  return (
    <GTMProvider state={gtmParams}>
      <QueryProvider>
        <LastLocationProvider>
          <ScrollToTop>
            {THEME && (
              <ThemeProvider theme={THEME}>
                <SnackbarProvider>
                  <CssBaseline />
                  <RouteHandler
                    isAuthenticated={AccountStore.meta.isAuthenticated}
                    routes={routes}
                  />
                </SnackbarProvider>
              </ThemeProvider>
            )}
          </ScrollToTop>
        </LastLocationProvider>
      </QueryProvider>
    </GTMProvider>
  )
})

export default App
